import React from "react";

import { IProduct } from "../../../models/catalogue.interfaces";
import { money } from "../../../utils/format";

import styles from "./index.module.scss";

interface IProps {
    productPrice: IProduct["price"];
    preCopy?: string;
}

export const DynamicPrice = (props: IProps): React.JSX.Element => {
    const { productPrice } = props;
    if (productPrice.cosmetic_incl_tax !== productPrice.incl_tax) {
        return (
            <div className={styles.priceWrapper}>
                <span className={styles.strikeThruPrice}>
                    {props.preCopy}{" "}
                    <s key="strikeThruPrice">{money(productPrice.incl_tax)}</s>
                </span>
                <span className={styles.price}>
                    {money(productPrice.cosmetic_incl_tax)}
                </span>
            </div>
        );
    }
    return <div className={styles.price}>{money(productPrice.incl_tax)}</div>;
};
